import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import classNames from 'classnames';

import ListItemText from '@material-ui/core/ListItemText';

import { BlueRightArrowIcon } from '../../../images/icons/WrapSvg';

class MenuItem extends React.Component {
    render() {
        const { primary, intl, icon, last, active } = this.props;

        return (
            <div
                className={
                    'flex_auto_row padding_top_12 margin_bottom_12 margin_left_12 hand  align_center ' +
                    (active ? 'c_bluish' : 'c_grey_blue')
                }
                onClick={this.props.onClick}
                onKeyDown={this.props.onClick}
            >
                {icon}
                <div
                    className={classNames(
                        'flex_full_row  margin_left_12',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <ListItemText
                        primary={intl.formatMessage({ id: primary })}
                        classes={{
                            primary:
                                'barlow_medium ' +
                                (active ? 'c_bluish' : 'c_grey_blue'),
                        }}
                    />
                    <BlueRightArrowIcon color="primary" />
                </div>
            </div>
        );
    }
}

MenuItem.propTypes = {
    intl: intlShape.isRequired,
};

MenuItem = injectIntl(MenuItem);

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/complex/manage/MenuItem.js